<template>

    <Toast/>

    <MenuMain/>
    <MenuPmModuleOverview v-if="(this.userStore.user.roles.includes('ROLE_ISOPRACTICE', 0))"/>
    <MenuMsModuleOverview v-else-if="(this.userStore.user.roles.includes('ROLE_ISOEVOLVE', 0))"/>
    <HeadingOverviewQualification/>

    <div class="px-6 surface-overlay relative">

        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Qualification</h3>

                    <div class="field">
                        <label for="inPrivatePractice">Are You In Private Practice?</label>
                        <Dropdown v-model="companyConfiguration.inPrivatePractice" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="region">Region</label>
                        <Dropdown v-model="companyConfiguration.region" :options="regionTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Region"/>
                    </div>

                    <div class="field">
                        <label for="practitionerType">Practitioner Type</label>
                        <Dropdown v-model="companyConfiguration.practitionerType" :options="practitionerTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Practitioner Type"/>
                    </div>

                    <div class="field">
                        <label for="turnover">Current Turnover</label>
                        <Dropdown v-model="companyConfiguration.turnover" :options="turnoverTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Turnover"/>
                    </div>

                    <div class="field">
                        <label for="requireAppointmentScheduling">Require an Appointment Scheduling System (phone, email
                            or online)?</label>
                        <Dropdown v-model="companyConfiguration.requireAppointmentScheduling" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requireClientIntake">Require a Client Intake Capturing System?</label>
                        <Dropdown v-model="companyConfiguration.requireClientIntake" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requireBilling">Require a Billing System?</label>
                        <Dropdown v-model="companyConfiguration.requireBilling" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requirePaymentAllocation">Require a Payment Allocation System?</label>
                        <Dropdown v-model="companyConfiguration.requirePaymentAllocation" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requireHealthInsuranceSubmission">Require a Health Insurance Submission
                            System?</label>
                        <Dropdown v-model="companyConfiguration.requireHealthInsuranceSubmission" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requireHealthInsuranceFollowups">Require a Health Insurance Follow-Up
                            System?</label>
                        <Dropdown v-model="companyConfiguration.requireHealthInsuranceFollowups" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requireUnpaids">Require an Unpaids Management System?</label>
                        <Dropdown v-model="companyConfiguration.requireUnpaids" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requireFinancials">Require a Financial Processing System?</label>
                        <Dropdown v-model="companyConfiguration.requireFinancials" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requireWebsite">Do You Have a Website?</label>
                        <Dropdown v-model="companyConfiguration.haveWebsite" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requireReferrals">Require Referrals?</label>
                        <Dropdown v-model="companyConfiguration.requireReferrals" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requireCommittment">Can You Commit to Working with Kitrin for At Least 6 Months to
                            See a Positive Result in Your Private Practice?</label>
                        <Dropdown v-model="companyConfiguration.requireCommittment" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requireUnderstandingConfirmation">Do You Understand that the IsoEvolve MS Module
                            Works on the Input -> Processing -> Output Model and Inputs are Also Required from
                            You?</label>
                        <Dropdown v-model="companyConfiguration.requireModelUnderstanding" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requireTimingConfirmation">Do You Understand that Each Request Can Take at Least One
                            (1) Working Day, and the Duration is Dependant on the Type of Task?</label>
                        <Dropdown v-model="companyConfiguration.requireTimingConfirmation" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requirePrepaidConfirmation">Do You Understand that There is An Additional Cost Per
                            Healthcare Insurance Claim (which is paid using a prepaid concept)?</label>
                        <Dropdown v-model="companyConfiguration.requirePrepaidConfirmation" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requireUnpaidLetterConfirmation">Do You Understand that There is An Additional Cost
                            Per Registered Unpaid Letter (which is paid using a prepaid concept)?</label>
                        <Dropdown v-model="companyConfiguration.requireUnpaidLetterConfirmation" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div class="field">
                        <label for="requirePricingConfirmation">Do You Understand that the IsoEvolve MS Module Pricing
                            is Discounted for One Year and that the Normal Subscription Applies from Year Two
                            Onwards?</label>
                        <Dropdown v-model="companyConfiguration.requirePricingConfirmation" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <Button label="Save" class="mr-2 mb-2" @click="updateConfiguration"></Button>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuPmModuleOverview from "@/components/menu/pmmodule/MenuPmModuleOverview.vue";
import MenuMsModuleOverview from "@/components/menu/msmodule/MenuMsModuleOverview.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import MenuMain from "@/components/menu/common/MenuMain.vue";
import HeadingOverviewQualification from "@/components/heading/common/HeadingOverviewQualification.vue";
import CompanyService from "@/service/CompanyService";

export default {
    components: {
        HeadingOverviewQualification,
        MenuMain,
        MenuPmModuleOverview,
        MenuMsModuleOverview,
        IsoEvolveFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[PhoneCalls][mounted] Data = ", userData);
            console.log("[PhoneCalls][mounted] this.profile = ", this.profile);
        } catch (e) {
            console.error("[PhoneCalls][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            this.$router.push('login');
            return; // Exit early if getUser fails
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[PhoneCalls][mounted] userConfigData.data = ", userConfigData.data);
        } catch (e) {
            console.error("[PhoneCalls][mounted] Could not find user config for user = ", this.userStore.user.id);
        }

        try {
            const [companyConfigData] = await Promise.all([
                CompanyService.getCompanyConfiguration(this.profile.companyId)
            ]);

            this.companyConfiguration = companyConfigData.data;
            console.log("[PhoneCalls][mounted] companyConfigData.data = ", companyConfigData.data);

            this.loading = false;

        } catch (e) {
            console.error("[PhoneCalls][mounted] Error fetching additional data = ", e);
        }

        console.log("[PhoneCalls][mounted] this.userConfiguration = ", this.userConfiguration);
        console.log("[PhoneCalls][mounted] this.companyConfiguration = ", this.companyConfiguration);
    },
    data() {

        return {
            profile: {},
            companyConfiguration: {},
            regionTypes: [
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'Canada', code: 'CA'},
                {name: 'United States', code: 'US'},
                {name: 'India', code: 'IN'}
            ],
            accountTypes: [
                {name: 'Healthcare Practitioner', code: 'H'},
                {name: 'Financial Advisor', code: 'F'},
                {name: 'Small Business', code: 'S'}
            ],
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            turnoverTypes: [
                {name: 'Under R10,000', code: 'A'},
                {name: 'Between R10,000 and R30,000', code: 'B'},
                {name: 'Between R30,000 and R60,000', code: 'C'},
                {name: 'Over R60,000', code: 'D'},
            ],
            practitionerTypes: [
                {name: 'Occupational Therapist', code: 'A'},
                {name: 'Clinical Psychologist', code: 'B'},
                {name: 'Counselling Psychologist', code: 'C'},
                {name: 'Educational Psychologist', code: 'D'},
                {name: 'Industrial Psychologist', code: 'E'},
                {name: 'Psychologist', code: 'F'},
                {name: 'Psychiatrist', code: 'G'},
                {name: 'Social Worker', code: 'H'},
                {name: 'Registered Counsellor', code: 'I'},
                {name: 'Physiotherapist', code: 'J'},
                {name: 'Speech Therapist', code: 'K'},
                {name: 'Audiologist', code: 'L'},
                {name: 'Speech Therapist and Audiologist', code: 'M'},
                {name: 'Biokineticist', code: 'N'},
                {name: 'Dietician', code: 'O'},
                {name: 'Chiropractor', code: 'P'},
                {name: 'Podiatrist', code: 'Q'},
                {name: 'GP', code: 'R'},
                {name: 'Dentist', code: 'S'},
                {name: 'Specialist Physician', code: 'T'},
                {name: 'Other', code: 'U'}
            ]
        }
    },
    methods: {
        async updateConfiguration() {

            var updatedConfiguration = {
                inPrivatePractice: this.companyConfiguration.inPrivatePractice,
                region: this.companyConfiguration.region,
                practitionerType: this.companyConfiguration.practitionerType,
                turnover: this.companyConfiguration.turnover,
                requireAppointmentScheduling: this.companyConfiguration.requireAppointmentScheduling,
                requireClientIntake: this.companyConfiguration.requireClientIntake,
                requireBilling: this.companyConfiguration.requireBilling,
                requirePaymentAllocation: this.companyConfiguration.requirePaymentAllocation,
                requireHealthInsuranceSubmission: this.companyConfiguration.requireHealthInsuranceSubmission,
                requireHealthInsuranceFollowups: this.companyConfiguration.requireHealthInsuranceFollowups,
                requireUnpaids: this.companyConfiguration.requireUnpaids,
                requireFinancials: this.companyConfiguration.requireFinancials,
                haveWebsite: this.companyConfiguration.haveWebsite,
                requireReferrals: this.companyConfiguration.requireReferrals,
                requireCommittment: this.companyConfiguration.requireCommittment,
                requireModelUnderstanding: this.companyConfiguration.requireModelUnderstanding,
                requireTimingConfirmation: this.companyConfiguration.requireTimingConfirmation,
                requirePrepaidConfirmation: this.companyConfiguration.requirePrepaidConfirmation,
                requireUnpaidLetterConfirmation: this.companyConfiguration.requireUnpaidLetterConfirmation,
                requirePricingConfirmation: this.companyConfiguration.requirePricingConfirmation,
            };

            try {
                // Delete the appointment
                const response = await CompanyService.updateCompanyConfiguration(this.profile.companyId, updatedConfiguration);
                console.log('[PhoneCalls][deletePhoneCall] Response = ', response);

                const [companyConfigData] = await Promise.all([
                    CompanyService.getCompanyConfiguration(this.profile.companyId)
                ]);

                this.companyConfiguration = companyConfigData.data;
                console.log("[PhoneCalls][mounted] companyConfigData.data = ", companyConfigData.data);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Configuration updated',
                    life: 3000
                });

            } catch (error) {
                console.error('[PhoneCalls][deletePhoneCall] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update configuration. Please try again.',
                    life: 3000
                });
            }

        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
